"use strict";

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 *
 * Custom logics to hide and show theme section (TBD)
 *
 * if (window.location.pathname == "/pages/fine-jewelry") {
 *   const urlParams = new URLSearchParams(window.location.search);
 *   const value = urlParams.get("utm_campaign");
 *   const slideshowNodes = document.querySelectorAll(".Slideshow");
 *   if(value && value.includes("Divine Grace")) {
 *     // hide Phoenix Hero section
 *     slideshowNodes[1].style.display = "none";
 *   } else {
 *     // hide Divine Grace Hero section
 *     slideshowNodes[0].style.display = "none";
 *     // hide Divine Grace Copy
 *     document.querySelector(".divine-grace-section--copy").style.display = "none";
 *     // hide Divine Grace Mosaic images
 *     document.querySelector(".mosaic-images-section").style.display = "none";
 *   }
 * }
 */

/*
 *  Global Variables
 */

var rewardData = {};

function onTidioChatApiReady() {
  // Code after chat loaded
  // check the url parameter
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  var action = urlParams.get("action");
  // open tidio chat when action = livechat
  if (action === "livechat") tidioChatApi.open();
  // hide tidio if Cart drawer is opened
  var drawer = document.getElementById("sidebar-cart");
  if (drawer && drawer.getAttribute("aria-hidden") === "false") {
    tidioChatApi.hide();
  }
}

if (window.tidioChatApi) {
  window.tidioChatApi.on("ready", onTidioChatApiReady);
} else {
  document.addEventListener("tidioChat-ready", onTidioChatApiReady);
}

function showProductItemLabel() {
  var labelNodes = document.querySelectorAll(".ProductItem__Label");
  labelNodes.forEach(function (node) {
    if (node) {
      node.style.setProperty("display", "block");
    }
  });
}

function setupResizeObserverForProductItemLabel() {
  if (window.ResizeObserver) {
    var resizeObserver = new ResizeObserver(function () {
      var element = document.querySelector(".ProductListWrapper .ProductItem");
      var positionInfo = element ? element.getBoundingClientRect() : null;
      var quickViewWrapperElements = document.querySelectorAll(".QuickView__Wrapper");
      var quickAddWrapperElements = document.querySelectorAll(".QuickView__MobileWrapper");
      var quickModalElement = document.querySelector(".Modal__Quickview");
      var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      if (positionInfo && positionInfo.width) {
        // update product-item width
        document.documentElement.style.setProperty("--product-item-width", positionInfo.width + "px");
        // show product label
        showProductItemLabel();

        if (isMobile) {
          showQuickAddOnMobile(quickViewWrapperElements, quickAddWrapperElements, isMobile);
        } else {
          if (window.innerWidth <= 768) {
            quickModalElement.classList.remove("Modal");
            quickModalElement.classList.add("QuickAdd__Popup");
            showQuickAddOnMobile(quickViewWrapperElements, quickAddWrapperElements, isMobile);
          } else {
            quickModalElement.classList.add("Modal");
            quickModalElement.classList.remove("QuickAdd__Popup");
          }
        }
      }
    });
    var observeElement = document.querySelector(".ProductListWrapper")
      ? document.querySelector(".ProductListWrapper")
      : document.querySelector(".ProductRecommendations");
    if (observeElement) {
      resizeObserver.observe(observeElement);
    }
  } else {
    console.log("Resize observer not supported!");
  }
}

function showQuickAddOnMobile(quickViewWrapperElements, quickAddWrapperElements, isMobile) {
  quickViewWrapperElements.forEach(function (element) {
    element.classList.add("hidden");
  });

  quickAddWrapperElements.forEach(function (element) {
    element.classList.remove("hidden");
    if (!isMobile) {
      element.classList.add("mobile");
    }
  });
}

function updateCartIndicator(cart) {
  var cartFreeShippingThreshold = parseInt(document.getElementById("cart-free-shipping-threshold").value);
  var cartFreeGiftThreshold = parseInt(document.getElementById("cart-free-gift-threshold").value);
  var cart_total_price = cart.total_price / 100;
  var shipping_percentage = 0;
  if (cartFreeShippingThreshold && cart_total_price > cartFreeShippingThreshold) {
    shipping_percentage = 100;
  } else {
    shipping_percentage = (cart_total_price * 100) / cartFreeShippingThreshold;
  }
  document.documentElement.style.setProperty("--shipping-progress-bar-width", shipping_percentage + "%");

  var free_gift_percentage = 0;
  if (cartFreeGiftThreshold && cart_total_price > cartFreeGiftThreshold) {
    free_gift_percentage = 100;
  } else {
    free_gift_percentage = (cart_total_price * 100) / cartFreeGiftThreshold;
  }
  document.documentElement.style.setProperty("--free-gift-progress-bar-width", free_gift_percentage + "%");
}

function geoLocationStoreCheck() {
  var geoLocationCountryStoreGroups = [
    {
      countryCodes: ["CA"],
      storeName: "Canada",
      forceRedirect: false,
      redirectUrl: "https://www.shenyuncollections.ca",
    },
    {
      countryCodes: [
        "AT",
        "BE",
        "BG",
        "CY",
        "CZ",
        "DE",
        "DK",
        "EE",
        "ES",
        "FI",
        "FR",
        "GR",
        "HR",
        "HU",
        "IE",
        "IT",
        "LT",
        "LU",
        "LV",
        "MT",
        "NL",
        "PL",
        "PT",
        "RO",
        "SE",
        "SI",
        "SK",
      ],
      storeName: "Europe",
      forceRedirect: false,
      redirectUrl: "https://www.shenyuncollections.de",
    },
    {
      countryCodes: [
        "IN",
        // "CN",
        "ID",
        "PK",
        "BD",
        "JP",
        "PH",
        "VN",
        "TH",
        "MM",
        "KR",
        "MY",
        "NP",
        "AU",
        // "KP",
        "LK",
        "KH",
        "PG",
        "LA",
        "SG",
        "NZ",
        "MN",
        "TL",
        "FJ",
        "SB",
        "MV",
        "BN",
        "NC",
        "KI",
        "FM",
        "TO",
        "MH",
        "PW",
        "CK",
        "TV",
        "NU"
      ],
      storeName: "Taiwan",
      forceRedirect: false,
      redirectUrl: "https://www.shenyuncollections.tw",
    },
  ];
  if (sessionStorage.getItem("geo-popup") !== "true") {
    var apiUrl = "https://".concat(window.theme.syshopApiBase, "/ip");
    var geoSelect = document.querySelector(".GeoLocation__CountryList select");
    var AnouBar = document.querySelector(".AnnouncementBar");
    var geoPopup = document.querySelector(".GeoLocationPopup");
    if (!geoSelect || !geoPopup) return;
    fetch(apiUrl)
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        var detectedStoreName = void 0;
        var isForceRedirect = false;
        var redirectUrl = void 0
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (
            var _iterator = geoLocationCountryStoreGroups[Symbol.iterator](), _step;
            !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
            _iteratorNormalCompletion = true
          ) {
            var countryStoreGroup = _step.value;

            if (countryStoreGroup.countryCodes.includes(response.country_code)) {
              detectedStoreName = countryStoreGroup.storeName;
              isForceRedirect = countryStoreGroup.forceRedirect;
              redirectUrl = countryStoreGroup.redirectUrl;
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if ((detectedStoreName && isForceRedirect == false ) || 
          (detectedStoreName && isForceRedirect == true && sessionStorage.getItem("force-redirected") === "true")) {
          // AnouBar.style.display = "none";
          geoSelect.value = detectedStoreName;
          var changeEvent = new Event("change");
          geoSelect.dispatchEvent(changeEvent);
          geoPopup.setAttribute("aria-hidden", "false");
        } else if (detectedStoreName && isForceRedirect == true && sessionStorage.getItem("force-redirected") !== "true") {
          // force redirect only once if user hasn't been redirected in the same session
          sessionStorage.setItem("force-redirected", "true");
          window.location.href = redirectUrl;
        }
      })
      ["catch"](function (error) {
        //handle error
        console.error("Error:", error);
      });
  }

  geoSelect.addEventListener("change", function (e) {
    var optionSelected = geoSelect.options[geoSelect.selectedIndex];
    document
      .querySelector(".GeoLocation__CountryButton a")
      .setAttribute("href", optionSelected.getAttribute("data-target"));
  });

  document.querySelector(".GeoLocationPopup__Close").onclick = function () {
    // AnouBar.style.display = "";
    geoPopup.setAttribute("aria-hidden", "true");
    sessionStorage.setItem("geo-popup", "true");
  };
}

function productStickyCTAObserver() {
  var elementIntersectMap = {};
  var productGallaryElem = document.querySelector(".Product__Gallery");
  var productMetaElem = document.querySelector(".ProductMeta");
  var productFormElem = document.querySelector(".ProductForm__BuyButtons");

  if (productGallaryElem && productMetaElem && productFormElem) {
    elementIntersectMap[productGallaryElem.className] = false;
    elementIntersectMap[productMetaElem.className] = false;
    elementIntersectMap[productFormElem.className] = false;

    var stickyProductObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        elementIntersectMap[entry.target.className] = entry.isIntersecting;
      });

      var HeaderF = document.querySelector(".Header__FlexProductBox");
      if (
        Object.values(elementIntersectMap).reduce(function (accumulator, currentValue) {
          return accumulator || currentValue;
        })
      ) {
        HeaderF.style.opacity = "0";
        HeaderF.style.zIndex = "-5";
      } else {
        HeaderF.style.zIndex = "4";
        HeaderF.style.opacity = "1";
      }
    });
    stickyProductObserver.observe(productGallaryElem);
    stickyProductObserver.observe(productMetaElem);
    stickyProductObserver.observe(productFormElem);
  }
}

function signupFormObserver() {
  // Observer for Omnisend's form container
  // Select the nodetree that will be observed for mutations
  var nodetree = document.getElementsByTagName("body")[0];
  // Select the target node atributes (CSS selector)
  var targetNode = ".soundest-form-without-image-overlay";
  // Options for the observer (which mutations to observe)
  var config = { attributes: false, childList: true, subtree: true };
  // Callback function to execute when mutations of DOM tree are observed
  var callback = function callback(mutations_on_DOMtree) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (
        var _iterator2 = mutations_on_DOMtree[Symbol.iterator](), _step2;
        !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done);
        _iteratorNormalCompletion2 = true
      ) {
        var mutation = _step2.value;

        if (mutation.type == "childList") {
          if (document.querySelector(targetNode) != null) {
            // register a click handlder for the overlay
            document.querySelector(targetNode).addEventListener("click", function () {
              console.log("clicked callback");
              document.querySelector("a.soundest-form-without-image-close").click();
            });
            //after action is done, disconnect the observer from the nodetree
            observerOfSignupForm.disconnect();
          }
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  };
  // Create an observer instance linked to the callback function
  var observerOfSignupForm = new MutationObserver(callback);
  // Start observing the target node for configured mutations
  observerOfSignupForm.observe(nodetree, config);
}

function initRewardsData() {
  let customer_data = document.querySelector("#rewards-init");
  if (customer_data && customer_data.dataset && customer_data.dataset.customerId) {
    let retry = 0;
    const params = new URLSearchParams(window.location.search);
    const currentPage = window.location.pathname;
    const previousPage = document.referrer;
    if (params && params.get("initial-login") && params.get("initial-login")=='true') {
      retry = 3;
    } else if (currentPage && currentPage == '/account' && previousPage && previousPage.includes('/challenge')) {
      retry = 3;
    }
    fetchRewardData(customer_data.dataset.customerId, retry);
  }
}

function fetchRewardData(id, retries) {
  const apiUrl = "https://".concat(window.theme.skycmsApiBase, "/reward/api/get-rewards");
  fetch(apiUrl + "?id=" + id)
    .then(function (res) {
      return res.json();
    })
    .then(function (reward) {
      rewardData = reward;
      
      if (reward && reward.status == 1) {
        //continue
      } else if (reward && reward.status == 0 && retries > 0) {
        return setTimeout(function () {
          console.log("[loyalty] retry");
          fetchRewardData(id, retries-1);
        }, 1000);
      } else {
        let rewardSummaryBkgdMobile = document.querySelector(".syshop-reward-summary-bkgd-mobile");
        if (rewardSummaryBkgdMobile) {
          rewardSummaryBkgdMobile.classList.remove('block');
          rewardSummaryBkgdMobile.classList.add('hidden');
        }
        return;
      }

      console.log("[loyalty] loaded");

      let summaryNode = document.querySelector("#syshop-reward-summary");
      if (summaryNode) summaryNode.classList.remove("hidden");

      var current_points = reward.points.points;
      if (document.getElementById("stamped-rewards-points-placeholder")) document.getElementById("stamped-rewards-points-placeholder").innerHTML = current_points;
      if (document.querySelector(".rewards-points-container")) document.querySelector(".rewards-points-container").classList.remove("hidden");

      var html = '<div class="font-sans rounded-md text-black cursor-pointer" style="background-color: #FFD3C1; min-width: 70px;">';
      html += '<span class="text-center text-xs">' + current_points + ' pts</span></div>';
      var account_node = document.querySelector("#loyalty-points");
      account_node.innerHTML = html;

      if (document.querySelector("#syshop-current-tier-skeleton")) {
        document.querySelector("#syshop-current-tier-skeleton").classList.add("hidden");
        html = '<h3 class="font-serif text-md font-semibold mt-1" style="color: #675745;">';
        html += '<span id="vip-tier" class="">' + reward.customer.vipTierTitle + ' Member</span></h3>';
        var tiername_node = document.createElement("div");
        tiername_node.innerHTML = html;
        document.querySelector("#syshop-current-tier-skeleton").append(tiername_node);
        document.querySelector("#syshop-current-tier-skeleton + h3 #vip-tier").innerHTML = reward.customer.vipTierTitle + " Member";
        document.querySelector("#syshop-current-tier-skeleton + h3 #vip-tier").classList.remove("hidden");  
      }

      // update reward info
      const rewardElement = document.getElementById('syshop-reward');
      if (!rewardElement) {
        return;
      }
      const currentPointsNode = document.querySelector('#syshop-reward #current-points');
      const requirePointsNode = document.querySelector('#syshop-reward #require-points');
      const nextTierNode = document.querySelector('#syshop-reward #next-tier');
      const skeleton = document.getElementById('syshop-reward-skeleton');
      // const skeletonMemberDiscount = document.getElementById('syshop-member-discount-skeleton');
      const skeletonCurrentTier = document.getElementById('syshop-current-tier-skeleton');
      // const memberDiscountNode = document.getElementById('member-discount');
      const vipTierNode = document.getElementById('vip-tier');
      const vipAnnouncementMobileNode = document.getElementById('vip-announcement-mobile');
      const vipAnnouncementDesktopNode = document.getElementById('vip-announcement-desktop');
      const rewardsActivitiesNode = document.getElementById('stamped-rewards-widget');
      currentPointsNode.innerText = current_points;

      // static texts based on locale
      let congratsTitle = "Congratulations!";
      let congratsSubtitle = "You are in our highest VIP tier";
      let member = "member";
      if (window.theme.shop_locale.toLowerCase() == 'zh-tw') {
        congratsTitle = "恭喜";
        congratsSubtitle = "您已達到最高的會員級別";
        member = "會員";
      }

      // calcualte the required points to the next tier
      const currentTier = reward.customer.vipTierTitle;
      const eligiblePoints = reward.customer.vipTierEligibleValue;
      const { nextTierTitle, requiredPoint } = calculateRequiredPoints(reward.customer.vipTierId, eligiblePoints, reward.vip_tiers);
      if (requiredPoint === 0) {
        requirePointsNode.innerText = `${congratsTitle}`;
        nextTierNode.innerText = `${congratsSubtitle}`;
      } else {
        requirePointsNode.innerText = requirePointsNode.innerText.replace("0", requiredPoint.toString());
        nextTierNode.innerText = `${nextTierTitle} ${member}`;
      }

      let currentTierStr = translateTierTitle(currentTier);
      vipTierNode.innerText = vipTierNode.innerText.replace("tier", currentTierStr.toString());
      if(currentTier) {
        vipAnnouncementMobileNode.style.display = "block";
        vipAnnouncementDesktopNode.style.display = "block";
      }

      var memberDiscount = 0;
      switch(currentTier) {
        case "Bronze": {
            memberDiscount = 10;
            break;
        }
        case "Silver": {
            memberDiscount = 15;
            break;
        }
        case "Gold": {
            memberDiscount = 20;
            break;
        }
        case "Platinum": {
            memberDiscount = 25;
            break;
        }
        default: {
            memberDiscount = 10;
            break;
        }
      }
      // memberDiscountNode.innerText = memberDiscountNode.innerText.replace("0", memberDiscount.toString()).replace("tier", currentTierStr.toString());

      skeleton.classList.add('hidden');
      // skeletonMemberDiscount.classList.add('hidden');
      skeletonCurrentTier.classList.add('hidden');
      rewardElement.classList.remove('hidden');
      // memberDiscountNode.classList.remove('hidden');
      vipTierNode.classList.remove('hidden');
  
      if (rewardsActivitiesNode) {
        var activitiesHtml = '<h3 class="stamped-rewards-widget-heading-main">Reward Activities</h3>';
        activitiesHtml += '<div class="table-wrapper" style="overflow-x:auto;"><table><tbody><tr class="activity-headers"><td><div class="activity-description">Activity</div></td><td><div class="activity-description">Date</div></td></tr>';
        var activityList = reward.activityList;
        if (activityList != null) {
          for (var i = 0; i < activityList.length; i++) {
            var activity = activityList[i];
            var name = "";
            if (activity.voided > 0) {
              name += "(Void) ";
            }
            if (activity.ruleId) {                  
              name += reward.earnRuleMap[activity.ruleId];
            } else if (activity.benefitId) {
              name += reward.benefitMap[activity.benefitId];
            }
            if (activity.voided > 0) {
              name += '<br>Void reason: ' + reward.voidReasonMap[activity.voided];
            }
            var points = "";
            if (activity.ruleId) {
              points += "+ ";
            } else if (activity.benefitId) {
              points += "- ";
            }
            points += activity.pointsAmt;
            activitiesHtml += '<tr><td><div class="activity-description">' + name + '<div class="activity-points">' + points + ' Points</div></div></td>';
            activitiesHtml += '<td><div class="activity-description">' + activity.timeCreatedDisplay + '</div></td></tr>';
          }
        }
        activitiesHtml += '</tbody></table></div>';
        rewardsActivitiesNode.innerHTML = activitiesHtml;
        rewardsActivitiesNode.classList.remove('hidden');
      }
    })
    ["catch"](function (error) {
      console.error("Error:", error);
  });
}

function calculateRequiredPoints(currentTier, eligiblePoints, vipTiers) {
  let nextTierTitle = "";
  let nextTierGoalValue = 0;
  for (let i = 0; i < vipTiers.length; i++) {
    if (vipTiers[i].Id === currentTier) {
      // found the current Tier define,
      if (i == vipTiers.length - 1) {
        // hightest tier
        nextTierTitle = translateTierTitle(vipTiers[i].Title);
        nextTierGoalValue = 0;
      } else {
        nextTierTitle = translateTierTitle(vipTiers[i + 1].Title);
        nextTierGoalValue = vipTiers[i + 1].GoalValue;
      }
    }
  }

  if (nextTierGoalValue === 0) {
    // highest level
    return { nextTierTitle, requiredPoint: 0 }
  }

  return { nextTierTitle, requiredPoint: nextTierGoalValue - eligiblePoints }
}

function translateTierTitle(tier) {
  if (window.theme.shop_locale.toLowerCase() == 'zh-tw') {
    switch(tier) {
      case "Silver": {
        return "銀";
      }
      case "Gold": {
        return "金";
      }
      case "Platinum": {
        return "白金";
      }
      default: {
        return "銅";
      }
    }
  } else {
    return tier;
  }
}

/*
 * Extend the jQuery serializeArray function to return a JSON format
 */
function serializeFormJSON(form) {
  var o = {};
  var ar = serializeArray(form);
  ar.forEach(function (a) {
    if (o[a.name]) {
      if (!o[a.name].push) {
        o[a.name] = [o[a.name]];
      }

      o[a.name].push(a.value || "");
    } else {
      o[a.name] = a.value || "";
    }
  });
  return o;
}

// custom serializeArray()
function serializeArray(form) {
  var arr = [];
  Array.prototype.slice.call(form.elements).forEach(function (field) {
    if (!field.name || field.disabled || ["file", "reset", "submit", "button"].indexOf(field.type) > -1) return;

    if (field.type === "select-multiple") {
      Array.prototype.slice.call(field.options).forEach(function (option) {
        if (!option.selected) return;
        arr.push({
          name: field.name,
          value: option.value,
        });
      });
      return;
    }

    if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked) return;
    arr.push({
      name: field.name,
      value: field.value,
    });
  });
  return arr;
}

/*
 * VIP Rewards Redeem points customization code
 */
function _skyVipDiscountInitialize() {
  // check if customer is logged in first
  var customer_data = document.querySelector("#rewards-init");
  if (!customer_data) return;
  // check if customer is loyalty member
  if (rewardData && rewardData.customer) {
    // display redeem points link in cart page
    var loyaltyNode = document.getElementById("loyalty-node");
    var redeemComp = document.getElementById("loyalty-redeem-component");
    if (loyaltyNode && redeemComp && redeemComp.classList.contains("hidden")) {
      loyaltyNode.classList.remove("hidden");
    }
  }
}

function showLoyaltyValue(sliderValue) {
  var redeemPreviewNode = document.getElementById("redeem-value-preview");
  var dollar = sliderValue / 50;
  redeemPreviewNode.innerText = sliderValue + " points = $" + dollar;
}

/**
 * deprecated, replaced with refreshing cart
 */
/*
function _resetLoyaltyElements() {
  var node = void 0;
  node = document.getElementById("loyalty-coupon-selector");
  if (node && node.classList.contains("hidden")) {
    node.classList.remove("hidden");
  }

  node = document.getElementById("loyalty-redeem-component");
  if (node && !node.classList.contains("hidden")) {
    node.classList.add("hidden");
  }

  node = document.getElementById("loyalty-redeem-point-disclaimer");
  if (node && !node.classList.contains("hidden")) {
    node.classList.add("hidden");
  }

  node = document.getElementById("loyalty-redeem-point-error");
  if (node && !node.classList.contains("hidden")) {
    node.classList.add("hidden");
  }
}
*/

function redeemLoyaltyPoints(event) {
  // pevent form submit
  event.preventDefault();

  var buttonNode = document.querySelector("#loyalty-redeem-component #redeem-button");
  var loadingSVG = buttonNode.querySelector("svg");
  var buttonText = buttonNode.querySelector("span");
  var discountError = document.querySelector("#loyalty-redeem-point-error");
  discountError && discountError.classList.add("hidden");

  var sliderInputNode = document.querySelector("#loyalty-redeem-component input");
  var redeemPoints = sliderInputNode.value; // current slider value

  // show loading indicator
  buttonText.classList.toggle("hidden");
  loadingSVG.classList.toggle("hidden");

  var customer_data = document.querySelector("#rewards-init");
  var apiUrl = "https://".concat(window.theme.skycmsApiBase, "/reward/api-redeem/redeem");
  return fetch(apiUrl+ "?points=" +
      redeemPoints,
    {
      method: "POST",
      body: JSON.stringify({
        customerId: customer_data.dataset.customerId,
        customerEmail: customer_data.dataset.customerEmail,
        customerAuth: rewardData.customer.authToken,
      }),
    }
  )
    .then(function (res) {
      return res.json();
    })
    .then(function (response) {
      // restore button state
      buttonText.classList.toggle("hidden");
      loadingSVG.classList.toggle("hidden");

      // redeem successfully
      var couponCode = response.couponCode;
      applyDiscountInCart(couponCode);

      rewardData.points.points -= redeemPoints;

      // reset the redeem points layout
      // _resetLoyaltyElements();
    })
    ["catch"](function (error) {
      console.error("Error:", error);
    });
}

function redeemPointsOnClick(cart_total_price) {
  // hide the selector
  var selector = document.getElementById("loyalty-coupon-selector");
  selector.classList.add("hidden");
  var discountError = document.getElementById("loyalty-redeem-point-error");
  discountError && discountError.classList.add("hidden");

  // setup and show redeem point slider
  var sliderContainerNode = document.getElementById("loyalty-redeem-component");
  sliderContainerNode && sliderContainerNode.classList.remove("hidden");

  // get the customer available points
  var availablePoints = rewardData.points.points;
  var cartTotalEquivalentPoints = cart_total_price / 100 * 50;
  var maxRedeemablePoints = Math.min(availablePoints, cartTotalEquivalentPoints);

  // get max redeemable points
  var max = maxRedeemablePoints - (maxRedeemablePoints % 50);
  if (sliderContainerNode) {
    var sliderInputNode = sliderContainerNode.querySelector("input");
    sliderInputNode.max = max;
    sliderInputNode.value = max;
  }

  // update redeem preview label
  var dollar = max / 50;
  var redeemPreviewNode = document.getElementById("redeem-value-preview");
  if (redeemPreviewNode) {
    redeemPreviewNode.innerText = max + " points = $" + dollar;
  }

  // error handling, when point is not available
  if (max == 0) {
    // disable redeem button
    var buttonNode = document.querySelector("#loyalty-redeem-component #redeem-button");
    buttonNode.setAttribute("disabled", true);
    buttonNode.classList.add("Button--secondary");
  }

  // unhide elements
  var disclaimer = document.getElementById("loyalty-redeem-point-disclaimer");
  disclaimer && disclaimer.classList.remove("hidden");
}

/*
*  Special customization for free gift (DEPRECATED)
*  Rules: Order value needs to be over a certain amount to eligible for the free gift item.
*         If overall cart value is lower then the defined minimum, remove the gift automatically.
*  id: variant id
*/ 
/*
function freeGiftCampaign(cart) {

  if (window.theme.enableAutoFreeGift && Number(window.theme.freeGiftThreshold) > 0 && window.theme.freeGiftId) {
    var FREE_GIFT_OFFER_VALUE = Number(window.theme.freeGiftThreshold);
    var FREE_GIFT = {id: Number(window.theme.freeGiftId)};
    var { items, total_price } = cart;
    if (!items || !cart) return;
    var total = total_price / 100;

    // limit the eligible products to certain group(s)
    var eligible_total = 0;
    for (let i = 0; i < items.length; i++) {
      var line_item = items[i];
      if (items[i].vendor && items[i].vendor.toLowerCase().includes("shen yun collections")) {
        eligible_total += line_item.final_line_price;
      }
    }
    total = eligible_total / 100;

    if (total >= FREE_GIFT_OFFER_VALUE && !ifCartHasItem(items, FREE_GIFT.id)) {
      // add free gift
      addToCart({
        items: [
          {
            id: FREE_GIFT.id,
            quantity: 1
          }
        ]
      })
      .then(() => {
        // trigger the cart refresh
        refreshCartHandler();
      })
      .catch((error) => {
        console.log(error)
      })
    } else if (total < FREE_GIFT_OFFER_VALUE && ifCartHasItem(items, FREE_GIFT.id)) {
      // remove free gift from cart
      changeCart({
        id: String(FREE_GIFT.id),
        quantity: 0
      })
      .then(() => {
        // trigger the cart refresh
        refreshCartHandler();
      })
      .catch((error) => {
        console.log(error)
      })
    }
  }
  return;
}
*/

/*
*  Special customization for loyalty free gift (DEPRECATED)
*  Rules: remove free gift if order total is below or at threshold
*  id: variant id
*/ 
/*
function freeGiftLoyalty(cart) {
  if (window.theme.enableLoyaltyFreeGift && Number(window.theme.loyaltyFreeGiftThreshold) >= 0 && window.theme.loyaltyFreeGiftId) {
    var { items, total_price } = cart;
    var total = total_price / 100;
    if (total <= Number(window.theme.loyaltyFreeGiftThreshold) && ifCartHasItem(items, Number(window.theme.loyaltyFreeGiftId))) {
      // remove free gift from cart
      changeCart({
        id: String(window.theme.loyaltyFreeGiftId),
        quantity: 0
      })
      .then(() => {
        // trigger the cart refresh
        refreshCartHandler();
      })
      .catch((error) => {
        console.log(error)
      })
    }
  }
  return;
}
*/

function freeGiftHandler(cart) {
  var { items, total_price } = cart;
  if (!items || !cart) return;
  var total = total_price / 100;

  var itemsToAdd = [];
  var itemsToRemove = {};

  if (window.theme.enableAutoFreeGift && Number(window.theme.freeGiftThreshold) > 0 && window.theme.freeGiftId) {
    var FREE_GIFT_OFFER_VALUE = Number(window.theme.freeGiftThreshold);
    var FREE_GIFT_ID = Number(window.theme.freeGiftId);
    if (total >= FREE_GIFT_OFFER_VALUE && !ifCartHasItem(items, FREE_GIFT_ID)) {
      itemsToAdd.push({
        id: FREE_GIFT_ID,
        quantity: 1
      });
    } else if (total < FREE_GIFT_OFFER_VALUE && ifCartHasItem(items, FREE_GIFT_ID)) {
      itemsToRemove[`${FREE_GIFT_ID}`] = 0;
    }
  }

  if (window.theme.enableLoyaltyFreeGift && Number(window.theme.loyaltyFreeGiftThreshold) >= 0 && window.theme.loyaltyFreeGiftId) {
    if (total <= Number(window.theme.loyaltyFreeGiftThreshold) && ifCartHasItem(items, Number(window.theme.loyaltyFreeGiftId))) {
      itemsToRemove[`${Number(window.theme.loyaltyFreeGiftId)}`] = 0;
    }
  }

  //TO DO: Bug: need to remove old free gift from cart if no active campaign

  if (itemsToAdd && itemsToAdd.length) {
    addToCart({
      items: itemsToAdd
    }, refreshCartHandler);
  }

  if (!isObjEmpty(itemsToRemove)) {
    updateCart(itemsToRemove);
  }
}

function isObjEmpty (obj) {
  return Object.keys(obj).length === 0;
}

/*
*  Special customization for loyalty free holiday gift
*  Rules: limit 1 per customer
*/ 
function freeHolidayGiftLoyalty(cart) {
  var { items } = cart;
  if (!items || !cart) return;
  var giftCount = 0;
  var giftUpdates = {};
  for (let i = 0; i < items.length; i++) {
    if (items[i].vendor && items[i].vendor.toLowerCase().includes("holiday gift for loyalty members")) {
      giftCount += 1;
      if (giftCount == 1) {
        giftUpdates[`${items[i].id}`] = 1
      } else {
        giftUpdates[`${items[i].id}`] = 0
      }
    }
  }
  if (giftCount > 0) updateCart(giftUpdates);
}

function applyDiscountInCart(discountCode) {
  const existingDiscounts = getExistingDiscounts();
  if (existingDiscounts.includes(discountCode)) return;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(
      { 
        discount: [...existingDiscounts, discountCode].join(','),
        // sections: ["mini-cart"]
      }
    ),
  })
  .then(res => res.json())
  .then((data) => {
    if (
      data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
        return discount.code === discountCode && discount.applicable === false;
      })
    ) {
      handleDiscountErrorInCart();
      return;
    }
    // trigger the cart refresh
    refreshCartHandler();
  })
  .catch(err => console.log(err));
}

/**
 * Returns an array of existing discount codes.
 * @returns {string[]}
 */
function getExistingDiscounts() {
  const discountCodes = [];
  const discountPills = document.querySelectorAll('.Cart__Discount');
  for (const pill of discountPills) {
    if (pill instanceof HTMLElement && typeof pill.dataset.discountCode === 'string') {
      discountCodes.push(pill.dataset.discountCode);
    }
  }
  return discountCodes;
}

function handleDiscountErrorInCart() {
  var discountError = document.getElementById("loyalty-redeem-point-error");
  discountError && discountError.classList.remove("hidden");
}

// change cart item quantity
function changeCart(itemInfo) {
  return fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(itemInfo),
  });
}

// update cart item quantity
function updateCart(updates) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  }).then(() => {
    // trigger the cart refresh
    refreshCartHandler();
  })
  .catch((error) => {
    console.log(error)
  });
}

// add item to cart
function addToCart(data, success_cb, error_cb) {
  let dataJson = {
    items: data.items,
  };

  document.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

  return fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(dataJson),
  })
    .then(function (response) {
      if (response.ok) {
        success_cb && success_cb();
        document.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        document.documentElement.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: response.variant_id,
              quantity: response.quantity,
            },
          })
        );
      } else {
        console.error("Error:", response.status);
      }
    })
    ["catch"](function (error) {
      error_cb && error_cb();
      console.error("Error:", error);
    });
}

function ifCartHasItem(items, id) {
  for (var i = 0; i < items.length; i++) {
    if (items[i].id === id) {
      return true;
    }
  }
  return false;
}

function refreshCartHandler() {
  setTimeout(function () {
    if (window.location.pathname.includes("/cart")) {
      window.location.reload();
    } else {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
    }
  }, 500);
}

//
function initThemeEventListeners() {
  document.addEventListener("product:updated", function (event) {
    var cart = event.detail.cart;
    // update shippingCartIndicator
    // updateCartIndicator(cart);
    freeGiftHandler(cart);
    // freeGiftCampaign(cart); //deprecated
    // freeGiftLoyalty(cart); //deprecated
    // freeHolidayGiftLoyalty(cart);
  });

  document.addEventListener("product:added", function (event) {
    // convert $.getJSON() to fetch()
    fetch("/cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        // update shippingCartIndicator
        // updateCartIndicator(cart);
        freeGiftHandler(cart);
        // freeGiftCampaign(cart); //deprecated
        // freeHolidayGiftLoyalty(cart);
      })
      ["catch"](function (error) {
        //handle error
        console.error("Error:", error);
      });
  });

  document.addEventListener("theme:loading:end", function (event) {
    // show product label after theme loaded
    showProductItemLabel();
  });

  document.addEventListener('discount_kit:cart_changed', () => {
    // Update/re-render your theme's ajax cart here
    refreshCartHandler();
  });
}

// Create userAgentIsReady events
function userAgentIsReady() {
  document.dispatchEvent(
    new CustomEvent("userAgentIsReady", {
      detail: {
        isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      },
    })
  );
}

// Handling Choose variations on Cross-sell ProductItem
function changeSelectCrossellVariant() {
  document.addEventListener("change", function (event) {
    // listen to the change event of the document, if not the change even of the Select input elements named 'cr-listen' of CrosssellProductItem, return
    if (event.target.name != "cr-listen") return;
    // convert the target Select element's id string into an array to get the variant type, variant id, product id
    var splitIdTarget = event.target.id.split("-");
    // assign variables to check if CrosssellProductItem has 2nd variant type and Select element of 2nd variant type
    var moreTypeSelect = splitIdTarget[1] == "colors" ? "sizes" : "colors";
    var moreTypeSelectE = document.getElementById(
      "cr-" + moreTypeSelect + "-" + splitIdTarget[2] + "-" + splitIdTarget[3]
    );
    // compare in turn over options containing the values of the variants of the Select element which stores the values of all product variants
    document.getElementById("cr-variants-value-" + splitIdTarget[2]).options.forEach(function (option) {
      // convert the string of option value storing variant title into an array to get the values of the variant type to compare
      var splitVariantTitle = option.getAttribute("value").split("/");
      if (moreTypeSelectE == null) {
        // the case that the 2nd Select element does not exist
        // if the first child value of the splitVariantTitle array is equal to the value of the Select element target or in the case where the value type of the Select element target is 'sizes' and the 2nd child value is equal to the value of the Select element target (in case of variable there can be one hidden color value and multiple size values)
        if (
          splitVariantTitle[0].trim() == event.target.value ||
          (splitIdTarget[1] == "sizes" && splitVariantTitle[1].trim() == event.target.value)
        ) {
          handleCrossellSelectChange(splitIdTarget, moreTypeSelect, moreTypeSelectE, option, event); // handleCrossellSelectChange function is called
        }
      } else {
        // case exists 2nd Select element
        if (splitIdTarget[1] == "colors") {
          // case the value type of Select element target is 'colors'
          if (
            splitVariantTitle[0].trim() == moreTypeSelectE.value &&
            splitVariantTitle[1].trim() == event.target.value
          ) {
            handleCrossellSelectChange(splitIdTarget, moreTypeSelect, moreTypeSelectE, option, event);
          }
        } else {
          // case the value type of Select element target is 'sizes'
          if (
            splitVariantTitle[0].trim() == event.target.value &&
            splitVariantTitle[1].trim() == moreTypeSelectE.value
          ) {
            handleCrossellSelectChange(splitIdTarget, moreTypeSelect, moreTypeSelectE, option, event);
          }
        }
      }
    });
  });

  function handleCrossellSelectChange(splitIdTarget, moreType, moreTypeE, op, e) {
    // function that handles when the value of Select element target is changed
    // get a Select element whose value is set to display consistent with the variant title of CrosssellProductItem displayed
    var setsE1 = document.getElementById(
      "cr-" + splitIdTarget[1] + "-" + splitIdTarget[2] + "-" + op.getAttribute("variant-id")
    );
    var hideE = document.getElementById("cr-variant-id-" + splitIdTarget[3]); // CrosssellProductItem hide
    var showE = document.getElementById("cr-variant-id-" + op.getAttribute("variant-id")); // CrosssellProductItem show
    // hide CrosssellProductItem containing target Select element
    hideE.classList.remove("flex");
    hideE.classList.add("hidden");
    // show CrosssellProductItem is called corresponding to the value of Select element target has changed
    showE.classList.remove("hidden");
    showE.classList.add("flex");

    // display the value of the Select element consistent with the variant title of that CrosssellProductItem when it is displayed
    setsE1.options.forEach(function (op2) {
      op2.removeAttribute("selected");
    });

    setsE1.options.forEach(function (op2) {
      if (op2.getAttribute("value") == e.target.value) {
        op2.setAttribute("selected", "true");
      }
    });

    if (moreTypeE != null) {
      // case exists 2nd Select element
      // get a Select element whose value is set to display consistent with the variant title of CrosssellProductItem displayed
      var setsE2 = document.getElementById(
        "cr-" + moreType + "-" + splitIdTarget[2] + "-" + op.getAttribute("variant-id")
      );

      // display the value of the Select element consistent with the variant title of that CrosssellProductItem when it is displayed
      setsE2.options.forEach(function (op3) {
        op3.removeAttribute("selected");
      });

      setsE2.options.forEach(function (op3) {
        if (op3.getAttribute("value") == moreTypeE.value) {
          op3.setAttribute("selected", "true");
        }
      });
    }
  }
}

function handleBundleColorSwatchClick(event) {
  if (event.target.classList.contains("ColorSwatch__Radio")) {
    var productBundleItem = event.target.closest(".product-bundle-item");
    var selectedValue = productBundleItem.querySelector(".ProductForm__SelectedValue");
    var currentVariant = productBundleItem.querySelector(".bundle-variants");
    var imageWrapperElements = productBundleItem.querySelectorAll(".image-item");

    currentVariant.value = event.target.getAttribute("variant-id");

    [].forEach.call(imageWrapperElements, function (image) {
      if (image.getAttribute("data-image-id") === event.target.getAttribute("data-image-id")) {
        image.classList.add("flex");
        image.classList.remove("hidden");
      } else {
        image.classList.add("hidden");
        image.classList.remove("flex");
      }
    });
    selectedValue.innerHTML = event.target.value;
  }
}

function handleBundleSizeSwatchClick(event) {
  if (event.target.classList.contains("SizeSwatch__Radio")) {
    var productBundleItem = event.target.closest(".product-bundle-item");
    var selectedValue = productBundleItem.querySelector(".ProductForm__SelectedValue");
    var currentVariant = productBundleItem.querySelector(".bundle-variants");
    var productBundleOptionElement = event.target.closest(".product-bundle-option");
    var bundleTabContentElement = event.target.closest(".bundle-tab-content");
    var bundlePriceElement = bundleTabContentElement.querySelector(".bundle-price");
    var bundleListItemElement = event.target.closest(".bundle-list-item");
    var sizeSwatchRadioList = bundleListItemElement.querySelectorAll(".SizeSwatch__Radio");

    productBundleOptionElement.querySelectorAll(".SizeSwatch__Radio").forEach(function (item) {
      item.removeAttribute("checked");
    });

    currentVariant.value = event.target.getAttribute("variant-id");
    selectedValue.innerHTML = event.target.value;
    event.target.setAttribute("checked", "checked");
    var finalPrice = 0;
    sizeSwatchRadioList.forEach(function (item) {
      if (item.getAttribute("checked")) {
        finalPrice += parseInt(item.getAttribute("variant-price"));
      }
    });
    bundlePriceElement.innerText = formatMoney(finalPrice, window.theme.moneyFormat);
  }
}

function showModalGift(event, gift_product_handle, giftVariantId, bundleSku) {
  var productBundleItem = event.target.closest(".bundle-tab-content");
  var bundleVariantElements = productBundleItem.querySelectorAll(".bundle-variants");
  var giftTitleElement = document.querySelector(".gift-title");
  var giftImageElement = document.querySelector(".gift-image");
  var giftVariantElement = document.querySelector(".gift-variant");
  var bundleProductIdsElement = document.querySelector(".bundle-product-ids");
  var bundleSkuElement = document.querySelector(".bundle-sku");
  var giftInfoSkeletonElement = document.querySelector(".gift-info-skeleton");
  var giftWrapperElement = document.querySelector(".gift-wrapper");
  var productFormOptionElements = document
    .querySelector(".gift-info")
    .querySelectorAll(".ProductForm__Option--labelled");

  giftInfoSkeletonElement.style.display = "block";
  giftWrapperElement.style.display = "none";
  var items = [];
  [].forEach.call(bundleVariantElements, function (variant) {
    if (variant.value) {
      if (!gift_product_handle) {
        items.push({
          quantity: 1,
          id: variant.value,
          properties: {
            _Bundle: bundleSku,
          },
        });
      } else {
        items.push(variant.value);
      }
    }
  });

  if (gift_product_handle) {
    giftTitleElement.innerText = "";
    giftVariantElement.innerText = "";
    bundleProductIdsElement.innerText = "";
    bundleSkuElement.innerText = "";
    giftImageElement.innerText = "";

    productFormOptionElements.forEach(function (optionItemElement) {
      if (optionItemElement) {
        optionItemElement.remove();
      }
    });

    fetch("".concat(window.routes.rootUrlWithoutSlash, "/products/").concat(gift_product_handle, ".js"), {
      credentials: "same-origin",
      method: "GET",
    }).then(function (response) {
      response.json().then(function (content) {
        var product = content;
        var selectedOrFirstAvailableVariant = false;
        var variants = product.variants;
        if (giftTitleElement) {
          giftTitleElement.innerText = content.title;
        }

        if (giftImageElement) {
          variants.forEach(function (variant, index) {
            if (variant.featured_image) {
              var giftImageItemElement = document.createElement("img");
              if (variant.available && !selectedOrFirstAvailableVariant) {
                selectedOrFirstAvailableVariant = true;
                giftImageItemElement.className = "gift-image-item flex";
              } else {
                giftImageItemElement.className = "gift-image-item hidden";
              }
              var image_variant_url = variant.featured_image.src;
              giftImageItemElement.setAttribute("src", image_variant_url);
              giftImageItemElement.setAttribute("data-image-id", variant.featured_image.id);
              giftImageElement.appendChild(giftImageItemElement);
            } else {
              var giftImageItemElement = document.createElement("img");
              var image_variant_url = content.featured_image;
              giftImageItemElement.setAttribute("src", image_variant_url);
              if (!selectedOrFirstAvailableVariant) {
                selectedOrFirstAvailableVariant = true;
                giftImageItemElement.className = "gift-image-item flex";
              } else {
                giftImageItemElement.className = "gift-image-item hidden";
              }
              giftImageElement.appendChild(giftImageItemElement);
            }
          });
        }

        if (giftVariantElement && content.available) {
          giftVariantElement.value = giftVariantId;
        }

        if (bundleProductIdsElement && items.length > 0) {
          bundleProductIdsElement.value = items.join();
        }

        if (bundleSkuElement && bundleSku) {
          bundleSkuElement.value = bundleSku;
        }

        fetchProductOption(product);

        giftInfoSkeletonElement.style.display = "none";
        giftWrapperElement.style.display = "block";
      });
    });
  } else {
    if (items.length > 0) {
      addToCart({
        items: items,
      });
    }
  }
}

function fetchProductOption(product) {
  var variants = product.variants;
  if (variants.length > 1) {
    var selectedVariantOptions = variants[0].options;
    var variantOption = document.querySelector(".gift-wrapper .ProductForm__Variants");
    var productOptions = product.options;

    if (productOptions.length > 0) {
      productOptions.forEach(function (optionItem, i) {
        if (optionItem.name && optionItem.name.toLowerCase() === "quality") {
          return true;
        } else if (optionItem.name && optionItem.name.toLowerCase() === "color") {
          variantOption.appendChild(createColorSwatch(product, optionItem, i, selectedVariantOptions));
        } else {
          variantOption.appendChild(createSizeSwatch(product, optionItem, i, selectedVariantOptions));
        }
      });
    }
  }
}

function handleGiftOptionChanged(event) {
  if (event.target.classList.contains("SizeSwatch__Radio")) {
    var giftVariantElement = document.getElementById("gift-variant");
    giftVariantElement.value = event.target.getAttribute("variant-id");
  }
}

function handleGiftColorOptionChanged(event) {
  if (event.target.classList.contains("ColorSwatch__Radio")) {
    var giftVariantElement = document.getElementById("gift-variant");
    giftVariantElement.value = event.target.getAttribute("variant-id");
    var giftWrapperItem = event.target.closest(".gift-wrapper");
    var imageWrapperElements = giftWrapperItem.querySelectorAll(".gift-image-item");

    [].forEach.call(imageWrapperElements, function (image) {
      if (image.getAttribute("data-image-id") === event.target.getAttribute("data-image-id")) {
        image.classList.add("flex");
        image.classList.remove("hidden");
      } else {
        image.classList.add("hidden");
        image.classList.remove("flex");
      }
    });
  }
}

function createColorSwatch(product, optionItem, optionIndex, selectedVariantOptions) {
  var position = optionIndex + 1;
  var modalProductGift = document.getElementById("modal-product-gift");
  var giftSettings = JSON.parse(modalProductGift.getAttribute("data-section-settings"));
  var variant_option = "option" + (optionIndex + 1);

  var imagePathStr = document.querySelector(".gift-images-path").getAttribute("data-images-path");
  imagePathStr = imagePathStr.substr(0, imagePathStr.lastIndexOf("/") + 1);
  var colorSwatchConfig = giftSettings["colorSwatchConfig"];
  var colorSwatchUl = document.createElement("ul");
  colorSwatchUl.setAttribute("class", "ColorSwatchList HorizontalList HorizontalList--spacingExtraTight");
  var optionItemValues = optionItem.values;

  if (optionItemValues.length > 1) {
    optionItemValues.forEach(function (optionValue, i) {
      var whiteColorStyle = optionValue.toLowerCase() === "white" ? "ColorSwatch--white" : "";
      var colorValue = optionValue.replace(/\s/g, "").toLowerCase();
      var backgroundColorName = "";
      var backgroundImageStyle = "";
      colorSwatchConfig.forEach(function (colorItem) {
        var colorSwatchParts = colorItem.split(":");
        var colorSwatchName = colorSwatchParts[0].replace(/\s/g, "").toLowerCase();
        var colorSwatchValue = colorSwatchParts[1];

        if (colorSwatchName == colorValue) {
          if (colorSwatchValue.includes("#")) {
            backgroundColorName = colorSwatchValue.substring(0, colorSwatchValue.length - 1);
          } else {
            backgroundImageStyle =
              "url(" + imagePathStr + colorSwatchValue.replace(/\s/g, "").toLowerCase().split(".")[0] + "_64x64.png)";
          }
        }
      });
      var variant_for_value = null;
      product.variants.forEach(function (variant, index) {
        if (variant[variant_option] == optionValue) {
          variant_for_value = variant;
        }
      });
      var isChecked = "";

      if (!selectedVariantOptions) {
        isChecked = i === 0 ? 'checked="checked"' : "";
      } else if (selectedVariantOptions.includes(optionValue)) {
        isChecked = 'checked="checked"';
      }

      var span = document.createElement("span");
      span.setAttribute("class", "u-visually-hidden");
      span.innerHTML = optionValue;
      var label = document.createElement("label");
      label.setAttribute("for", "option-product-template-" + optionIndex + "-" + i);
      label.setAttribute("class", "ColorSwatch ColorSwatch--large " + whiteColorStyle);
      label.setAttribute("data-tooltip", optionValue);
      label.style.backgroundColor = backgroundColorName;
      label.style.backgroundImage = backgroundImageStyle;
      label.appendChild(span);
      var input = document.createElement("input");
      input.setAttribute("id", "option-product-template-" + optionIndex + "-" + i);
      input.setAttribute("class", "ColorSwatch__Radio");
      input.type = "radio";
      input.name = "option-" + optionIndex;
      input.value = optionValue;
      if (variant_for_value) {
        input.setAttribute("variant-id", variant_for_value.id);
        input.setAttribute("data-image-id", variant_for_value.featured_image.id);
        input.setAttribute("onclick", "handleGiftColorOptionChanged(event)");
      }

      if (isChecked) {
        input.setAttribute("checked", isChecked);
      }

      input.setAttribute("data-option-position", position);
      var horizontalListItem = document.createElement("li");
      horizontalListItem.setAttribute("class", "HorizontalList__Item");
      horizontalListItem.appendChild(input);
      horizontalListItem.appendChild(label);
      colorSwatchUl.appendChild(horizontalListItem);
    });
  }

  var labelSpan = document.createElement("span");
  labelSpan.setAttribute("class", "ProductForm__Label");
  labelSpan.innerHTML = optionItem.name + ": ";
  var optionDiv = document.createElement("div");
  optionDiv.setAttribute("class", "ProductForm__Option ProductForm__Option--labelled flex");

  if (optionItemValues.length > 1) {
    optionDiv.appendChild(labelSpan);
    optionDiv.appendChild(colorSwatchUl);
  }

  return optionDiv;
}

function createSizeSwatch(product, optionItem, optionIndex, selectedVariantOptions) {
  var position = optionIndex + 1;
  var sizeSwatchUl = document.createElement("ul");
  sizeSwatchUl.setAttribute("class", "SizeSwatchList HorizontalList HorizontalList--spacingTight");
  var optionItemValues = optionItem.values;
  if (optionItemValues.length > 0) {
    optionItemValues.forEach(function (optionValue, i) {
      var isChecked = "";

      if (!selectedVariantOptions) {
        isChecked = i === 0 ? 'checked="checked"' : "";
      } else if (selectedVariantOptions.includes(optionValue)) {
        isChecked = 'checked="checked"';
      }

      var label = document.createElement("label");
      label.setAttribute("for", "option-product-template-" + optionIndex + "-" + i);
      label.setAttribute("class", "SizeSwatch");
      label.innerHTML = optionValue;
      var input = document.createElement("input");
      input.setAttribute("id", "option-product-template-" + optionIndex + "-" + i);
      input.setAttribute("class", "SizeSwatch__Radio");
      input.type = "radio";
      input.name = "option-" + optionIndex;
      input.value = optionValue;
      var currentVariant = getCurrentVariant(product, optionIndex, optionValue);
      if (currentVariant) {
        input.setAttribute("variant-id", currentVariant.id);
        input.setAttribute("onclick", "handleGiftOptionChanged(event)");
      }

      if (isChecked) {
        input.setAttribute("checked", isChecked);
      }

      input.setAttribute("data-option-position", position);
      var horizontalListItem = document.createElement("li");
      horizontalListItem.setAttribute("class", "HorizontalList__Item");
      horizontalListItem.appendChild(input);
      horizontalListItem.appendChild(label);
      sizeSwatchUl.appendChild(horizontalListItem);
    });
  }

  var labelSpan = document.createElement("span");
  labelSpan.setAttribute("class", "ProductForm__Label");
  labelSpan.innerHTML = optionItem.name + ":";
  var optionDiv = document.createElement("div");
  optionDiv.setAttribute("class", "ProductForm__Option ProductForm__Option--labelled flex");
  optionDiv.appendChild(labelSpan);
  optionDiv.appendChild(sizeSwatchUl);
  return optionDiv;
}

function getCurrentVariant(product, optionIndex, optionValue) {
  var found = null;
  product.variants.forEach(function (variant) {
    var selectedOptions = variant.options || [];
    if (selectedOptions.length > 0) {
      if (selectedOptions[optionIndex] == optionValue) {
        found = variant;
      }
    }
  });
  return found || null;
}

function addBundleToCart(event, isFreeGift) {
  var bundleProductIdsElement = document.querySelector(".bundle-product-ids");
  var giftVariantElement = document.querySelector(".gift-variant");
  var bundleSkuElement = document.querySelector(".bundle-sku");

  var variantId = "";
  if (isFreeGift) {
    var variantId = giftVariantElement.value;
    var productIds = bundleProductIdsElement.value.concat(",", variantId).split(",");
  } else {
    var productIds = bundleProductIdsElement.value.split(",");
  }

  var items = [];
  productIds.forEach((id) => {
    if (id == variantId) {
      var properties = {
        _bundle_related: bundleSkuElement.value,
      };
    } else {
      var properties = {
        _Bundle: bundleSkuElement.value,
      };
    }
    items.push({
      quantity: 1,
      id: id,
      properties: properties,
    });
  });

  if (items.length > 0) {
    addToCart({
      items: items,
    });
    document.getElementById("modal-product-gift").querySelector(".Modal__Close").click();
  }
}

function openBundleTab(event, tabName) {
  var tabContent = document.getElementsByClassName("product-bundle-list");
  for (var i = 0; i < tabContent.length; i++) {
    tabContent[i].style.display = "none";
  }
  var bundleTabLinks = document.getElementsByClassName("bundle-tab-links");
  for (var i = 0; i < bundleTabLinks.length; i++) {
    bundleTabLinks[i].querySelector("p").className = bundleTabLinks[i]
      .querySelector("p")
      .className.replace(" active", "");
  }
  if (document.getElementById(tabName)) {
    document.getElementById(tabName).style.display = "block";
  }

  event.currentTarget.querySelector("p").className += " active";
}

function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || "${{amount}}";

  var value = "";

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;

    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;

    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;

    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;

    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;

    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
  }

  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value).replace(",00", "");
  } else {
    return formatString.replace(placeholderRegex, value).replace(".00", "");
  }
}

function defaultTo(value, defaultValue) {
  return value == null || value !== value ? defaultValue : value;
}

function formatWithDelimiters(number, precision, thousands, decimal) {
  precision = defaultTo(precision, 2);
  thousands = defaultTo(thousands, ",");
  decimal = defaultTo(decimal, ".");

  if (isNaN(number) || number == null) {
    return 0;
  }

  number = (number / 100.0).toFixed(precision);
  var parts = number.split("."),
    dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
    centsAmount = parts[1] ? decimal + parts[1] : "";
  return dollarsAmount + centsAmount;
}

// Handling function when the scroll up and down event hides and shows the Navigation
function scrollUpDown() {
  var header = document.getElementById('section-header');
  if(!header.classList.contains('Header--center')) return;

  var doc = document.documentElement,
      w = window;
  var curScroll = w.scrollY || doc.scrollTop,
      prevScroll = w.scrollY || doc.scrollTop;
  var curDirection = 0,
      prevDirection = 0,
      threshold = 40,
      toggled;

  var navHeaderUl = document.querySelector('.Header__MainNav ul'),
      hamSidebar = document.getElementById('sidebar-menu-icon-btn');

  var checkScroll = function () {
    curScroll = w.scrollY || doc.scrollTop;
    if (Math.abs(curScroll - prevScroll) > threshold) {
      if(curScroll > prevScroll) {
        // scrolled down
        curDirection = 2;
      } else {
        // scrolled up
        curDirection = 1;
      }

      if(curDirection !== prevDirection) {
        toggled = toggleHeader();
      }

      if(toggled) {
        prevDirection = curDirection;
      }

      prevScroll = curScroll;
    }
  };

  var toggleHeader = function () {
    toggled = true;
    if(curDirection === 2) {
      if (navHeaderUl) navHeaderUl.style.opacity = "0";
      header.classList.add("Header--scroll");
      document.documentElement.style.setProperty('--header-height', '76px');
      hamSidebar.classList.remove('hidden-desk');
    }
    else if(curDirection === 1) {
      if (navHeaderUl) navHeaderUl.style.opacity = "1";
      header.classList.remove("Header--scroll");
      document.documentElement.style.setProperty('--header-height', '115px');
      hamSidebar.classList.add('hidden-desk');
    }
    else {
      toggled = false;
    }
    return toggled;
  };

  window.addEventListener("scroll", checkScroll);
}

// Open external links in a new tab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

/**
 * Retrieve UTM params from cookie
 * Cookie name is '_shopify_sa_p'
 */
function getCookie(cookieName) {
  let cookie = {};
  document.cookie.split(';').forEach(function(el) {
    let [key,value] = el.split('=');
    cookie[key.trim()] = value;
  })
  return cookie[cookieName];
}

// Get decoded utm parameter from encoded url string
function getUtmParam(utmString, paramName) {
  let utmParam = "";
  decodeURIComponent(utmString).split('&').forEach(el => {
      let [key,value] = el.split('=');
      if (key == paramName) utmParam = value;
  })
  return decodeURI(utmParam);
}

// Display a campaign msg in cart
function displayUtmCampaignMsg() {
  const campaignDiscountCode = String(window.theme.targeted_campaign_discount_code);
  if (window.theme.enable_targeted_campaign_discount && campaignDiscountCode) {

    let campaignMsgElement = document.querySelector(".click-to-apply-campaign-discount");
    const campaignName = String(window.theme.targeted_campaign_content);
    const campaignMsg = "Click to apply the TANG15 offer";
    
    if (campaignMsgElement && campaignName && matchUtmParam("utm_content", campaignName) && !isDiscountApplied(campaignDiscountCode)) {
      //exclusive to the campaign
      campaignMsgElement.innerText = campaignMsg;
      campaignMsgElement.classList.remove("hidden");
    } else if (campaignMsgElement && campaignName == "" && !isDiscountApplied(campaignDiscountCode)) {
      //inclusive
      campaignMsgElement.innerText = campaignMsg;
      campaignMsgElement.classList.remove("hidden");
    }
  }
}

function applyCampaignDiscount() {
  const campaignDiscountCode = String(window.theme.targeted_campaign_discount_code);
  let campaignMsgElement = document.querySelector(".click-to-apply-campaign-discount");

  if (!isDiscountApplied(campaignDiscountCode)) {
    // apply discount code to Stackable App
    let discountCodeInput = document.querySelector(".stkbl-text-field");
    let applyDiscountBtn = document.querySelector(".stkbl-input-form button");
    if (discountCodeInput && applyDiscountBtn) {
      discountCodeInput.value = campaignDiscountCode;
      discountCodeInput.dispatchEvent(new Event("input"));
      applyDiscountBtn.click();
      campaignMsgElement && campaignMsgElement.classList.add("hidden");
    }
  } else {
    campaignMsgElement && (campaignMsgElement.innerText = `${campaignDiscountCode} is already applied`);
  }
}

//check if a UTM param value is matched in the UTMs from the url query or stored from cookie
function matchUtmParam(paramName, paramValue) {
  // check the url query string
  let params = new URLSearchParams(window.location.search);
  let utm_value = "";
  if (params) utm_value = params.get(paramName);

  if (!utm_value) {
    // check cookie
    let cookieValue = getCookie("_shopify_sa_p");
    if (cookieValue) utm_value = getUtmParam(cookieValue, paramName);
  }

  if (utm_value && utm_value.toUpperCase() == paramValue.toUpperCase()) {
    return true;
  } else {
    return false;
  }
}

//check if a manual discount code has been already applied in the cart
function isDiscountApplied(searchDiscountCode) {
  let dicountCodesApplied = document.getElementsByClassName("stkbl-code-tag-promo-name");
  if (dicountCodesApplied) {
    for (let i = 0; i < dicountCodesApplied.length; i++) {
      if (dicountCodesApplied[i].textContent.toUpperCase() == searchDiscountCode.toUpperCase()) {
        return true;
      }
    }
  }
  return false;
}

function getTrackingCookie() {
  var cookies = document.cookie.split(";");
  var skycookieName = "__sky_id";
  var skycookieVal = "";
  for (var i = 0; i < cookies.length; i++) {
      var cookieName = cookies[i].substring(0, cookies[i].indexOf("="));
      cookieName = cookieName.trim();
      if (cookieName == skycookieName) {
        skycookieVal = cookies[i].substring(cookies[i].indexOf("=") + 1);;
        break;
      }
  }

  if ( skycookieVal.length == 0 ) {// get email to track parameter
    var queryString = window.location.search;
    var emailToTrackParam = "";
    if (queryString) {
      var urlParams = new URLSearchParams(queryString);
      emailToTrackParam = urlParams.get("_st");
    }

    if (emailToTrackParam && emailToTrackParam.length > 0) {
      var expDate = new Date();
      expDate.setDate(expDate.getDate() + 2 * 365);
      document.cookie = skycookieName + "=" + (emailToTrackParam + "; expires=" + expDate.toUTCString()) + "; path=/; domain=" + document.location.host;
      skycookieVal = emailToTrackParam;
    }
  }
  return skycookieVal;
}

function activeOnSite() {
  var skycookieVal = getTrackingCookie();
  if ( skycookieVal && skycookieVal.length > 0 ) {
    var apiUrl = "https://".concat(window.theme.skycmsApiBase, "/email/api-visit");
    fetch(apiUrl,
      {
        method: "POST",
        body: JSON.stringify({
          id: skycookieVal,
          userAgent: navigator.userAgent,
          userAgentData: navigator.userAgentData,
          webdriver: navigator.webdriver, // Indicates whether the user agent is controlled by automation
          language: navigator.language,
          cookieEnabled: navigator.cookieEnabled,
          referrer: document.referrer,
          page: document.location.href,
          isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        }),
      }
    )
    .then(function (res) {
      return res.json();
    })
    .then(function (response) {
    })
    ["catch"](function (error) {
        console.error("active on site record error:", error);
    });
  }
}

// Custom video control
const sound = `<svg width="36" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 11.88"><path style="fill: #FFFFFF; fill-rule: evenodd; fill-opacity: .3;" d="m11,5.96c0,1.09-.45,2.09-1.17,2.83l-.67-.67c.55-.56.89-1.31.89-2.16s-.34-1.61-.89-2.16l.67-.67c.75.75,1.17,1.77,1.17,2.83ZM6.72.22l-3.72,3.72H1c-.55,0-1,.45-1,1v2c0,.55.45,1,1,1h2l3.72,3.72c.47.47,1.28.14,1.28-.53V.75c0-.67-.81-1-1.28-.53Zm5.94.08l-.67.67c1.32,1.32,2.07,3.11,2.06,4.98,0,1.94-.78,3.7-2.06,4.98l.67.67c1.5-1.5,2.34-3.54,2.34-5.66,0-2.22-.89-4.22-2.34-5.66,0,0,0,.02,0,.02Zm-1.41,1.41l-.69.67c.95.95,1.48,2.24,1.48,3.58,0,1.39-.56,2.66-1.48,3.56l.69.67c1.12-1.12,1.75-2.64,1.75-4.23,0-1.65-.67-3.16-1.75-4.25Z"/></svg>`;
const mute = `<svg width="36" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.53 11.88"><path style="fill: #FFFFFF; fill-rule: evenodd; fill-opacity: .3;" d="m8,.75v10.38c0,.67-.81,1-1.28.53l-3.72-3.72H1c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1h2L6.72.22c.47-.47,1.28-.14,1.28.53Zm7.53,3.22l-1.06-1.06-1.97,1.97-1.97-1.97-1.06,1.06,1.97,1.97-1.97,1.97,1.06,1.06,1.97-1.97,1.97,1.97,1.06-1.06-1.97-1.97,1.97-1.97Z"/></svg>`;

function toggleSound(soundBtn, videoId) {
  let soundButton = soundBtn;
  let video = document.getElementById(videoId);
  if (video && soundBtn) {
    video.muted = !video.muted;
    soundButton.classList.add("activated");
    soundButton.innerHTML = video.muted ? mute : sound;
  }
}

function togglePlay(videoId) {
  let video = document.getElementById(videoId);
  if (video) {
    video.paused? video.play() : video.pause();
  }
}

function customerSignupTagging() {
  // check the url parameter
  let params = new URLSearchParams(window.location.search);
  // check utm in cookie
  let cookieValue = getCookie("_shopify_sa_p");

  let utm_source = "";
  let utm_campaign = "";
  let tags = "";

  if (params) {
    utm_source = params.get("utm_source");
    utm_campaign = params.get("utm_campaign");
  }

  if (!utm_source && cookieValue) {
    utm_source = getUtmParam(cookieValue, "utm_source");
  }
  if (!utm_campaign && cookieValue) {
    utm_campaign = getUtmParam(cookieValue, "utm_campaign");
  }

  utm_source && (tags += "Signup-".concat(utm_source));
  utm_campaign && (tags += ", Signup-campaign-".concat(utm_campaign));
  if (tags) {
    const tagNodeList = document.querySelectorAll(".signup_customer_tags");
    if (tagNodeList) {
      for (let i = 0; i < tagNodeList.length; i++) {
        tagNodeList[i].value = tagNodeList[i].value + ", " + tags;
      }
    }
  }
}

function spinner() {
  var buttons = document.querySelectorAll('[name="checkout_form"] .Button--spinner');
  for (var buttonNode of buttons) {
    buttonNode.addEventListener('click', () => {
      buttonNode.classList.add('spinningState');
    });
  }
}

const isValidEmail = (value) => {
  if (!value) {
    return false;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return false;
  } else {
    return true;
  }
}

// Handler for documentReady() called.
function customRun() {
  var _window$theme = window.theme,
    syshopGeolocationService = _window$theme.syshopGeolocationService;
    // omnisendIntegration = _window$theme.omnisendIntegration;

  // skycms loyalty program init
  initRewardsData();
  // theme product tag resize observer
  setupResizeObserverForProductItemLabel();
  // shop Geolocation server
  syshopGeolocationService && geoLocationStoreCheck();
  // sticky CTA on mobile
  productStickyCTAObserver();
  // omnisend signup form observer
  // omnisendIntegration && signupFormObserver();
  // prepare event listenrs
  initThemeEventListeners();
  // Run - Handling Choose variations on Cross-sell ProductItem
  changeSelectCrossellVariant();
  // Handling function when the scroll up and down event hides and shows the Navigation
  scrollUpDown();
  // create userAgentIsReady events
  userAgentIsReady();

  activeOnSite();
  // tagging signups source
  customerSignupTagging();
  spinner();
}

function documentReady(callback) {
  // in case the document is already rendered
  if (document.readyState != "loading") callback();
  // modern browsers
  else if (document.addEventListener) document.addEventListener("DOMContentLoaded", callback);
  // IE <= 8
  else
    document.attachEvent("onreadystatechange", function () {
      if (document.readyState == "complete") callback();
    });
}

// Run
documentReady(customRun);
